// import { readableBillingFrequencyUnit as readableBillingFrequencyUnitNEW } from '@zaplify/subscriptions';
// import { BillingPeriodUnit } from '../enums/billing';
// import { webCryptoRandom } from '@zaplify/frontend-common';

// const nonInitialModifiers = ['a', 'an', 'and', 'on', 'at'];

// export enum TextModifier {
//     EXCEPT_NON_INITIAL_ARTICLES = 'except-non-initial-articles',
// }

// type TextModifierOptions = TextModifier.EXCEPT_NON_INITIAL_ARTICLES;

// export function titleCase(str: string | undefined | null, options?: TextModifierOptions): string | null {
//     if (!str) {
//         return null;
//     }

//     return str
//         .toLowerCase()
//         .split(' ')
//         .map(function (word) {
//             if (
//                 !word[0] ||
//                 (options && options === TextModifier.EXCEPT_NON_INITIAL_ARTICLES && nonInitialModifiers.includes(word))
//             ) {
//                 return word;
//             }
//             return word.replace(word[0], word[0].toUpperCase());
//         })
//         .join(' ');
// }

// export function generateRandomLetter() {
//     const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

//     return alphabet[Math.floor(webCryptoRandom() * alphabet.length)];
// }

// export function toUpperCase(text: string) {
//     return text.charAt(0).toUpperCase() + text.slice(1);
// }

// /**
//  * @deprecated Please use the period.util functions from @zaplify/subscriptions instead
//  * @param billingPeriod
//  * @param billingPeriodUnit
//  * @returns
//  */
// export function readableBillingFrequencyUnit(
//     billingPeriod: number | undefined,
//     billingPeriodUnit: BillingPeriodUnit | undefined
// ): 'monthly' | 'quarterly' | 'half-year' | 'annually' {
//     return readableBillingFrequencyUnitNEW(billingPeriod, billingPeriodUnit);
// }

export const capitalizeFirstLetters = (word) => {
    if (!word || word === '') return '';
    return word
        .split(' ')
        .map((str) => (str = str.charAt(0).toUpperCase() + str.substring(1).toLowerCase()))
        .join(' ');
};

// export function replaceNewLinesWithBreaks(inputString: string): string {
//     return inputString.replace(/\\n/g, '<br />');
// }
